// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rG71","label":"styles_label__HLqPc"};